export default __webpack_public_path__ + "static/media/B52_14.f7185692.webp";